import Stack from '@/design_system/Stack';
import { Cell } from '@/design_system/Table/Table';
import InlineText from '@/design_system/Typography/InlineText';
import { ShipmentWithRelations, useCarrierName } from '@/models/shipment';

export const ShipmentReferenceAndCarrierCell = ({
  shipment,
}: {
  shipment: ShipmentWithRelations;
}) => {
  const carrierName = useCarrierName(shipment);

  return (
    <Cell isLink>
      <Stack>
        <span>{shipment.reference}</span>
        <InlineText size="300" color="secondary">
          {carrierName}
        </InlineText>
      </Stack>
    </Cell>
  );
};
